// wrapper, todo el dashboard vive en DashboardContent.
import React from 'react';
import DashboardContent from 'components/DashboardContent/DashboardContent';

const Dashboard = () => <DashboardContent />;

export default Dashboard;
